/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Image } from './Image';
import type { TileFeatures } from './TileFeatures';
import type { TileListing } from './TileListing';
import type { TileLocation } from './TileLocation';
import type { TileRate } from './TileRate';
import type { TileRating } from './TileRating';
export type ListingTile = {
    id?: string;
    name?: string;
    source?: ListingTile.source;
    rating?: TileRating;
    location?: TileLocation;
    features?: TileFeatures;
    images?: Array<Image>;
    path?: string;
    rate?: TileRate | null;
    foreignPartnerId?: number | null;
    listing?: TileListing;
};
export namespace ListingTile {
    export enum source {
        NOC = 'noc',
        NOP = 'nop',
    }
}
